export default __webpack_public_path__ + "static/media/non_actif_dark.f4d9a1a4.svg";